import React from "react";

export default function HeadIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4445 14.25C12.7315 14.25 12.1528 13.679 12.1528 12.975C12.1528 12.271 12.7315 11.7 13.4445 11.7C14.394 11.7 15.1667 10.9373 15.1667 10C15.1667 9.0625 14.394 8.3 13.4445 8.3H6.5555C5.60575 8.3 4.8335 9.0625 4.8335 10C4.8335 10.9373 5.60575 11.7 6.5555 11.7C7.26925 11.7 7.84725 12.271 7.84725 12.975C7.84725 13.679 7.26925 14.25 6.5555 14.25C4.18175 14.25 2.25 12.3433 2.25 10C2.25 7.65675 4.18175 5.75 6.5555 5.75H13.4445C15.8185 5.75 17.75 7.65675 17.75 10C17.75 12.3433 15.8185 14.25 13.4445 14.25Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const HeadWideIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6399 25.5481C23.6584 25.5481 22.8618 24.7621 22.8618 23.793C22.8618 22.8239 23.6584 22.0379 24.6399 22.0379C25.9469 22.0379 27.0106 20.988 27.0106 19.6979C27.0106 18.4074 25.9469 17.3578 24.6399 17.3578H15.1571C13.8497 17.3578 12.7867 18.4074 12.7867 19.6979C12.7867 20.988 13.8497 22.0379 15.1571 22.0379C16.1396 22.0379 16.9352 22.8239 16.9352 23.793C16.9352 24.7621 16.1396 25.5481 15.1571 25.5481C11.8896 25.5481 9.23047 22.9234 9.23047 19.6979C9.23047 16.4723 11.8896 13.8477 15.1571 13.8477H24.6399C27.9078 13.8477 30.5665 16.4723 30.5665 19.6979C30.5665 22.9234 27.9078 25.5481 24.6399 25.5481Z"
        fill="#222222"
      />
    </svg>
  );
};
